@if ((card?.template?.gameplay?.type??'') === 'tiles') {
  <div class="gameplay__container__box tiles__container">
    <mat-card class="card__container">
      <mat-card-content class="card__content">
      <nx-superprep-slide-panel [activePane]="activePane" [duration]="slideDuration">
          <div leftPane>
            <ng-container [ngTemplateOutlet]="tileTemplate"></ng-container>
          </div>
          <div rightPane>
            <ng-container [ngTemplateOutlet]="tileTemplate"></ng-container>
          </div>
      </nx-superprep-slide-panel>
      </mat-card-content>
    </mat-card>
  </div>
}

<ng-template #tileTemplate>
  <div class="header__container" [style.min-height]="headerContainerHeight">
    <ng-container
      [ngTemplateOutlet]="headerTemplate"
    ></ng-container>
  </div>
  <div class="choice__list__container">
    <ng-container
      [ngTemplateOutlet]="tileGridTemplate"
      [ngTemplateOutletContext]="{
        didAnswer: didAnswer,
        choices: choices
      }"
    ></ng-container>
  </div>
</ng-template>

<ng-template #headerTemplate>
  @if(shouldShowTopText) {
    <div
      class="header__content topText"
      [style.visibility]="!didAnswer && question?.topText ? 'visible' : 'hidden'"
      [style.margin]="question?.isImage ? '0' : 'initial'"
      [innerHTML]="topText() | safe: 'html'"
    ></div>
  }
  @if(shouldShowTextContent) {
    <div
      class="text__content"
      [ngClass]="didAnswer ? 'endText' : 'questionText'"
      [style.visibility]="isTextContentVisible ? 'visible': 'hidden'"
      [style.cursor]="didPlayAudio && !shouldShowPlayButton ? 'pointer' : 'unset'"
      [innerHTML]="(didAnswer ? endText() : questionText()) | safe: 'html'"
      (mousedown)="shouldShowPlayButton ? '' : onPlayButtonTap()"
    ></div>
  }
  @if(shouldShowPlayButton) {
    <div class="audio__container">
      <nx-superprep-play-button
        #audioButton
        [duration]="audioDuration"
        [diameter]="playButtonDiameter"
        (action)="onPlayButtonTap($event)"
      >
    </nx-superprep-play-button>
    </div>
  }
  @if (question?.isImage) {
    <div class="image">
      @if (!didAnswer && question?.hasImage) {
        <img
          mat-card-img
          class="image__container noborder"
          [src]="question?.imageUrl"
        />
      }
    </div>
  }
  <ng-container
    [ngTemplateOutlet]="translationTemplate"
    [ngTemplateOutletContext]="{
      didAnswer: didAnswer,
      translation: translation(),
      pronunciation: pronunciation(),
      shouldShowTranslation: shouldShowTranslation,
      shouldShowPronunciation: shouldShowPronunciation
    }"
  ></ng-container>
</ng-template>

<ng-template
  #translationTemplate
  let-didAnswer="didAnswer"
  let-translation="translation"
  let-pronunciation="pronunciation"
  let-shouldShowTranslation="shouldShowTranslation"
  let-shouldShowPronunciation="shouldShowPronunciation"
>
  <div class="translation__container">
    <p class="translation"
      [style.visibility]="shouldShowTranslation ? 'visible' : 'hidden'"
      [innerHTML]="translation | safe: 'html'"
    ></p>
    <p class="pronunciation"
      [style.visibility]="shouldShowPronunciation ? 'visible' : 'hidden'"
      [innerHTML]="pronunciation | safe: 'html'"
    ></p>
  </div>
</ng-template>

<ng-template
  #imageTileTemplate
  let-choice="choice"
>
  <img
    mat-card-img
    [src]="choice.imageUrl"
    [ngClass]="{
      border: true,
      elevated: isWeb,
      image__container: true,
      correct: isCorrect(choice)
    }"
  />
</ng-template>

<ng-template
  #textTileTemplate
  let-choice="choice"
>
  <div
    class="centered text__content"
    [ngClass]="{
      border: true,
      elevated: isWeb,
      background: true,
      image__container: true,
      correct: isCorrect(choice),
      endText: didAnswer,
      questionText: !didAnswer
    }"
  ><div
    class="centered"
    [ngStyle]="{'width':'100%', 'z-index':'-1'}"
    [innerHTML]="choiceLabel([choice, 0]) | safe: 'html'"
  ></div>
  </div>
</ng-template>

<ng-template
  #tileGridTemplate
  let-didAnswer="didAnswer"
  let-choices="choices"
  let-chosen="chosen"
  let-rowHeight="rowHeight"
>
  <mat-grid-list id="tile__grid" class="tile__grid" cols="{{cols}}" gutterSize="{{gutterSize}}">
    @for (choice of choices; track $index) {
      <mat-grid-tile
        [colspan]="1"
        [rowspan]="1"
        [ngClass]="{
          choice: !didAnswer,
          noborder: true,
          nohover: true,
          noactive: true,
          choice__container__box: true,
          selectable: !didAnswer,
          translucid: didAnswer && !choice.isAnswer
        }"
        [@headShake]="isAnimated(choice)"
        (mousedown)="onSelect(choice)"
      >
        @switch (choice.mimeBase) {
          @case ('image') {
            <ng-container
              [ngTemplateOutlet]="imageTileTemplate"
              [ngTemplateOutletContext]="{ choice:choice }"
            ></ng-container>
          }
          @case ('text') {
            <ng-container
              [ngTemplateOutlet]="textTileTemplate"
              [ngTemplateOutletContext]="{ choice:choice }"
            ></ng-container>
          }
        }
      </mat-grid-tile>
    }
  </mat-grid-list>
</ng-template>
